// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file wavin/sentio/v1/room_measurement.proto (package wavin.sentio.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file wavin/sentio/v1/room_measurement.proto.
 */
export const file_wavin_sentio_v1_room_measurement: GenFile = /*@__PURE__*/
  fileDesc("CiZ3YXZpbi9zZW50aW8vdjEvcm9vbV9tZWFzdXJlbWVudC5wcm90bxIPd2F2aW4uc2VudGlvLnYxIp0CCg9Sb29tTWVhc3VyZW1lbnQSMwoEdHlwZRgBIAEoDjIlLndhdmluLnNlbnRpby52MS5Sb29tTWVhc3VyZW1lbnQuVHlwZRItCgl0aW1lc3RhbXAYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg0KBXZhbHVlGAMgASgBIpYBCgRUeXBlEhQKEFRZUEVfVU5TUEVDSUZJRUQQABIYChRUWVBFX0FJUl9URU1QRVJBVFVSRRABEhoKFlRZUEVfRkxPT1JfVEVNUEVSQVRVUkUQAhIdChlUWVBFX1NFVFBPSU5UX1RFTVBFUkFUVVJFEAMSEQoNVFlQRV9IVU1JRElUWRAEEhAKDFRZUEVfQ08yX1BQTRAFQrEBChNjb20ud2F2aW4uc2VudGlvLnYxQhRSb29tTWVhc3VyZW1lbnRQcm90b1ABWiZ3YXZpbi5pby9nZW4vZ28vd2F2aW4vc2VudGlvL3YxO3NlbnRpb6ICA1dTWKoCD1dhdmluLlNlbnRpby5WMcoCD1dhdmluXFNlbnRpb1xWMeICG1dhdmluXFNlbnRpb1xWMVxHUEJNZXRhZGF0YeoCEVdhdmluOjpTZW50aW86OlYxYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * RoomMeasurement represents a single room measurement
 *
 * @generated from message wavin.sentio.v1.RoomMeasurement
 */
export type RoomMeasurement = Message<"wavin.sentio.v1.RoomMeasurement"> & {
  /**
   * @generated from field: wavin.sentio.v1.RoomMeasurement.Type type = 1;
   */
  type: RoomMeasurement_Type;

  /**
   * Timestamp measured value
   *
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp;

  /**
   * Value is measured value of given type
   *
   * @generated from field: double value = 3;
   */
  value: number;
};

/**
 * Describes the message wavin.sentio.v1.RoomMeasurement.
 * Use `create(RoomMeasurementSchema)` to create a new message.
 */
export const RoomMeasurementSchema: GenMessage<RoomMeasurement> = /*@__PURE__*/
  messageDesc(file_wavin_sentio_v1_room_measurement, 0);

/**
 * RoomMetric type
 *
 * @generated from enum wavin.sentio.v1.RoomMeasurement.Type
 */
export enum RoomMeasurement_Type {
  /**
   * @generated from enum value: TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TYPE_AIR_TEMPERATURE = 1;
   */
  AIR_TEMPERATURE = 1,

  /**
   * @generated from enum value: TYPE_FLOOR_TEMPERATURE = 2;
   */
  FLOOR_TEMPERATURE = 2,

  /**
   * @generated from enum value: TYPE_SETPOINT_TEMPERATURE = 3;
   */
  SETPOINT_TEMPERATURE = 3,

  /**
   * @generated from enum value: TYPE_HUMIDITY = 4;
   */
  HUMIDITY = 4,

  /**
   * @generated from enum value: TYPE_CO2_PPM = 5;
   */
  CO2_PPM = 5,
}

/**
 * Describes the enum wavin.sentio.v1.RoomMeasurement.Type.
 */
export const RoomMeasurement_TypeSchema: GenEnum<RoomMeasurement_Type> = /*@__PURE__*/
  enumDesc(file_wavin_sentio_v1_room_measurement, 0, 0);

